export var DEFAULT_PROFILES = {
  INFOLINE_RS: {
    nickname: "infoline_rs",
    sales_description: "infoline_rs",
    profile: [{
      "dnlpath_full_lines": "dnlpath:weblines.infoline_rs.*"
    }, {
      "dnlpath": "dnlpath:weblines.sportsline.topnews"
    }, {
      "dnlpath": "dnlpath:weblines.sportsline.fussball.erstebundesliga.spielberichte"
    }],
    extra: []
  },
  WEBLINES: {
    nickname: "weblines",
    sales_description: "infoline_rs,sportsline,starline,regioline,serviceline",
    profile: [{
      "dnlpath_full_lines": "dnlpath:weblines.infoline_rs.*"
    }, {
      "dnlpath": "dnlpath:weblines.sportsline.topnews"
    }, {
      "dnlpath": "dnlpath:weblines.sportsline.fussball.erstebundesliga.spielberichte"
    }, {
      "dnlpath_full_lines": "dnlpath:weblines.sportsline.*"
    }, {
      "dnlpath_full_lines": "dnlpath:weblines.starline.*"
    }, {
      "dnlpath_full_lines": "dnlpath:weblines.regiolinegeo.*"
    }, {
      "dnlpath_full_lines": "dnlpath:weblines.serviceline.*"
    }],
    extra: []
  },
  WIRES: {
    nickname: "wires",
    sales_description: "",
    profile: [{
      "dpasrv": "dpasrv:bdt"
    }],
    extra: []
  },
  BASISDIENST_BILDFUNK: {
    nickname: "bdt-psde",
    sales_description: "bdt,psde",
    profile: [{
      "dpasrv": "dpasrv:bdt"
    }, {
      "dpasrv": "dpasrv:photostream-de"
    }],
    extra: []
  },
  BASISPAKET: {
    nickname: "basispaket",
    sales_description: "basispaket:bdt,psde,\nhsh,brb,bay,\ninfoline_rs,sportsline,\nstarline,\nregioline(hsh,brb,bay)",
    profile: [{
      "dpasrv": "dpasrv:bdt"
    }, {
      "dpasrv": "dpasrv:photostream-de"
    }, {
      "dpasrv": "dpasrv:hsh"
    }, {
      "dpasrv": "dpasrv:brb"
    }, {
      "dpasrv": "dpasrv:bay"
    }, {
      "dnlpath_full_lines": "dnlpath:weblines.infoline_rs.*"
    }, {
      "dnlpath_full_lines": "dnlpath:weblines.sportsline.*"
    }, {
      "dnlpath_full_lines": "dnlpath:weblines.starline.*"
    }, {
      "dnlpath_mainrubrics": "dnlpath:weblines.regiolinegeo.hamburgschleswigholstein"
    }, {
      "dnlpath_mainrubrics": "dnlpath:weblines.regiolinegeo.berlinbrandenburg"
    }, {
      "dnlpath_mainrubrics": "dnlpath:weblines.regiolinegeo.bayern"
    }],
    extra: []
  },
  RADIOLINE: {
    nickname: "radioline",
    sales_description: "radioline",
    profile: [{
      "tagexp": "dnlpath:weblines.starline.(kino.*|leben.*|leute.*|musik.*)"
    }, {
      "tagexp": "dnlpath:weblines.infoline_rs.(panorama|politik.*)"
    }, {
      "dnlpath_mainrubrics": "dnlpath:weblines.sportsline.topnews"
    }, {
      "dnlpath_mainrubrics": "dnlpath:weblines.regiolinegeo.badenwuerttemberg"
    }],
    extra: []
  },
  NEWSSCREEN: {
    nickname: "newsscreen",
    sales_description: "newsscreen",
    profile: [{
      "dnlpath_full_lines": "dnlpath:weblines.newsscreen.*"
    }],
    extra: []
  },
  THEMENWELTEN: {
    nickname: "themenwelten",
    sales_description: "themenwelten",
    profile: [{
      "dpasrv": "dpasrv:themenwelten"
    }],
    extra: []
  },
  TRENDS: {
    nickname: "trends",
    sales_description: "trends",
    profile: [{
      "dpasrv": "dpasrv:feature-en"
    }, {
      "tagexp": "dpasrv:feature-special-en-(cars|digital|lifestyle|science|travel)"
    }],
    extra: []
  },
  INTERNATIONAL: {
    nickname: "international",
    sales_description: "englischer Dienst",
    profile: [{
      "dpasrv": "dpasrv:eca"
    }, {
      "dpasrv": "dpasrv:eca-3p"
    }],
    extra: []
  },
  INTERNACIONAL: {
    nickname: "internacional",
    sales_description: "spanischer Dienst",
    profile: [{
      "dpasrv": "dpasrv:dpa-espanol"
    }, {
      "dpasrv": "dpasrv:europapress-tem"
    }, {
      "dpasrv": "dpasrv:europapress-esp"
    }, {
      "dpasrv": "dpasrv:europapress-int"
    }],
    extra: []
  },
  INTERNATIONAL_ARABIC: {
    nickname: "international-arabic",
    sales_description: "arabischer Dienst",
    profile: [{
      "dpasrv": "dpasrv:text-arabic"
    }],
    extra: []
  },
  INTERNATIONAL_PHOTO: {
    nickname: "international-photo",
    sales_description: "internationaler Photodienst",
    profile: [{
      "dpasrv": "dpasrv:photostream-en-nat"
    }, {
      "dpasrv": "dpasrv:photostream-en-int"
    }, {
      "dpasrv": "dpasrv:photostream-en-3p"
    }],
    extra: []
  },
  KNA: {
    nickname: "kna",
    sales_description: "kna",
    profile: [{
      "tagexp": "dnlpath:kna-news.*"
    }],
    extra: [{
      "provider": "dnlprov:kna"
    }]
  },
  DEFAULT: {
    nickname: "default",
    sales_description: "infoline_rs",
    profile: [{
      "dnlpath_full_lines": "dnlpath:weblines.infoline_rs.*"
    }, {
      "dnlpath": "dnlpath:weblines.sportsline.topnews"
    }, {
      "dnlpath": "dnlpath:weblines.sportsline.fussball.erstebundesliga.spielberichte"
    }],
    extra: []
  }
};
export var defaultProfileMapper = function defaultProfileMapper(type) {
  return DEFAULT_PROFILES[type] || DEFAULT_PROFILES[DEFAULT];
};